export default {
      id: "icon--tooltip-close-usage",
      viewBox: "0 0 11 11",
      url: __webpack_public_path__ + "redesign-sprite.svg#icon--tooltip-close-usage",
      toString: function () {
        return this.url;
      }
    }